"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IlEventDetailModal = exports.IlEventDetailDatesArgs = exports.IlEventDetailNoButtonsArgs = exports.IlEventDetailDefaultArgs = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var enums_1 = require("../../shared/enums");
var il_dropdown_common_1 = require("../il-dropdown/il-dropdown.common");
var il_icon_common_1 = require("../il-icon/il-icon.common");
var solid_icon_definitions_1 = require("../il-icon/solid-icon-definitions");
var il_event_detail_1 = require("./il-event-detail");
exports.IlEventDetailDefaultArgs = {
    event: {
        assignedDate: new Date(),
        completedDate: new Date(),
        note: 'Egypt exhibition is on the third floor and runs from October 2020 through June of 2021.',
        eventIcon: enums_1.IconEnum.TROPHY,
        title: 'Museum Trip',
        scheduleWork: true,
        eventId: '0',
        studentId: '',
    },
    students: il_dropdown_common_1.StudentFilterImplementationArgs,
};
exports.IlEventDetailNoButtonsArgs = __assign(__assign({}, exports.IlEventDetailDefaultArgs), { showDelete: false, showEdit: false });
exports.IlEventDetailDatesArgs = __assign(__assign({}, exports.IlEventDetailDefaultArgs), { event: __assign(__assign({}, exports.IlEventDetailDefaultArgs.event), { assignedDate: new Date(2020, 5, 4), completedDate: new Date(2020, 5, 12) }) });
function IlEventDetailModal(_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, onClose = _a.onClose, _c = _a.maxWidth, maxWidth = _c === void 0 ? 'xs' : _c, dialogProps = _a.dialogProps, props = __rest(_a, ["open", "onClose", "maxWidth", "dialogProps"]);
    var fullScreen = (0, material_1.useMediaQuery)(function (theme) { return theme.breakpoints.down('md'); });
    return (react_1.default.createElement(material_1.Dialog, __assign({ onClose: onClose, open: open, maxWidth: maxWidth, fullScreen: fullScreen, PaperProps: { sx: { backgroundColor: 'background.default', pt: '1rem', px: '2rem' } } }, dialogProps),
        react_1.default.createElement(material_1.IconButton, { sx: {
                position: 'absolute',
                mt: '0.5rem',
                mr: '1rem',
                top: 0,
                right: 0,
            }, onClick: onClose, "data-testid": "close-icon" },
            react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.X_MARK_ICON, size: enums_1.IconSizeEnum.SMALL })),
        react_1.default.createElement(il_event_detail_1.ILEventDetail, __assign({}, props))));
}
exports.IlEventDetailModal = IlEventDetailModal;
